import scrollTo from "@degjs/scroll-to";

const anchorLinks = document.querySelectorAll('a[href^="#"]');

if (anchorLinks) {
  [].forEach.call(anchorLinks, (link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const linkId = link.getAttribute("href");
      const linkName = linkId.split("#")[1];

      if (linkName.length && !!document.getElementById(`${linkName}`)) {
        const elementPosition =
          document.getElementById(`${linkName}`).offsetTop - 172;

        scrollTo({
          position: elementPosition,
          duration: 500,
          easing: "easeInOut",
        });
      }
    });
  });
}
